// Copiato da https://github.com/react-bootstrap/react-overlays/blob/v1.2.0/src/utils/ownerWindow.js
import ReactDOM from 'react-dom';
import ownerWindow from 'dom-helpers/ownerWindow';

const reactOwnerWindow =  (componentOrElement) => {
  return ownerWindow(ReactDOM.findDOMNode(componentOrElement));
}
export default reactOwnerWindow;